<section class="flex flex-col">
  <span class="text-3xl font-bold font-inter">Add Expense Category</span>
  <form
    [formGroup]="form"
    (ngSubmit)="submit()"
    class="w-full mt-6 p-4 grid grid-cols-1 lg:grid-cols-2 gap-8"
  >
    <div class="flex flex-col space-y-8">
      <div class="flex flex-col space-y-2">
        <span class="font-medium">Expense Name</span>
        <input
          type="text"
          formControlName="name"
          class="h-12 rounded-lg text-sm p-4 text-[#5C5C5C] border border-gray-200 focus:outline-none"
          placeholder="Masukkan nama expense"
        />
      </div>
      <div class="flex flex-col space-y-2">
        <span class="font-medium">Type</span>
        <mat-select
          formControlName="type"
          placeholder="Pilih tipe"
          class="h-12 rounded-lg !text-sm px-4 py-3 !text-[#5C5C5C] border border-gray-200 focus:outline-none !font-display !tracking-normal"
        >
          <mat-option
            value="Reimbursment"
            class="!font-display !text-sm !tracking-normal"
            >Reimbursment</mat-option
          >
          <mat-option
            value="Cash Advance"
            class="!font-display !text-sm !tracking-normal"
            >Cash Advance</mat-option
          >
        </mat-select>
      </div>
      <div class="flex flex-col space-y-2">
        <div class="flex items-center justify-between">
          <span class="font-medium">Max Transaction Value</span>
          <mat-slide-toggle
            [checked]="this.form.get('max_transaction_value')?.value != 0"
            (change)="changeMaxValue($event)"
            color="black"
            formControlName="is_using_max"
            [style]=""
          ></mat-slide-toggle>
        </div>
        <input
          [readOnly]="!this.form.get('is_using_max')?.value"
          formatNumber
          formatCurrency
          type="text"
          formControlName="max_transaction_value"
          class="h-12 rounded-lg text-sm p-4 text-[#5C5C5C] border border-gray-200 focus:outline-none"
          [ngClass]="!this.form.get('is_using_max')?.value ? 'bg-gray-100' : ''"
          placeholder="Masukkan maks. transaksi"
        />
      </div>
      <!-- <div class="flex flex-col space-y-2">
        <span class="font-medium">Budget Period</span>
        <input
          formatNumber
          formatCurrency
          type="text"
          formControlName="budget_period"
          class="h-12 rounded-lg text-sm p-4 text-[#5C5C5C] border border-gray-200 focus:outline-none"
          placeholder="Masukkan periode budget"
        />
      </div>
      <div class="flex flex-col space-y-2">
        <span class="font-medium">Budget Amount</span>
        <input
          formatNumber
          formatCurrency
          type="text"
          formControlName="budget_amount"
          class="h-12 rounded-lg text-sm p-4 text-[#5C5C5C] border border-gray-200 focus:outline-none"
          placeholder="Masukkan jumlah budget"
        />
      </div>
      <div class="flex flex-col space-y-2">
        <span class="font-medium">Max Transaction Per Period</span>
        <input
          formatNumber
          formatCurrency
          type="text"
          formControlName="max_transaction_per_period"
          class="h-12 rounded-lg text-sm p-4 text-[#5C5C5C] border border-gray-200 focus:outline-none"
          placeholder="Masukkan maks. transaksi per periode"
        />
      </div> -->
    </div>
    <div class="flex flex-col space-y-8">
      <div class="flex flex-col space-y-2">
        <span class="font-medium">Icon</span>
        <mat-select
          formControlName="icon"
          placeholder="Pilih ikon"
          class="h-12 rounded-lg !text-sm px-4 py-3 !text-[#5C5C5C] border border-gray-200 focus:outline-none !font-display !tracking-normal"
        >
          <mat-option
            value="Yellow"
            class="!font-display !text-sm !tracking-normal"
            >Yellow</mat-option
          >
          <mat-option
            value="Blue"
            class="!font-display !text-sm !tracking-normal"
            >Blue</mat-option
          >
          <mat-option
            value="Pink"
            class="!font-display !text-sm !tracking-normal"
            >Pink</mat-option
          >
          <mat-option
            value="Green"
            class="!font-display !text-sm !tracking-normal"
            >Green</mat-option
          >
          <mat-option
            value="Red"
            class="!font-display !text-sm !tracking-normal"
            >Red</mat-option
          >
        </mat-select>
      </div>
      <div class="flex flex-col space-y-2">
        <span class="font-medium">Request Receipt Image</span>
        <mat-slide-toggle
          color="black"
          formControlName="request_receipt_image"
        ></mat-slide-toggle>
      </div>
    </div>
    <div class="lg:col-span-2 py-4">
      <mat-divider class="!border-gray-300"></mat-divider>
    </div>
    <div class="flex flex-col space-y-8 lg:col-span-2 w-full lg:w-2/3">
      <span class="font-semibold text-lg">Approval Flow</span>
      <mat-radio-group
        formControlName="own_approval_flow"
        aria-label="Select an option"
        class="flex flex-col space-y-6"
      >
        <mat-radio-button [value]="false">
          <div class="flex flex-col space-y-2 font-display">
            <span class="!text-base">Basic</span>
            <span class="!text-xs">All transaction approval by Superadmin</span>
          </div>
        </mat-radio-button>
        <mat-radio-button [value]="true">
          <div class="flex flex-col space-y-2 font-display">
            <span class="!text-base">Create my own approval flow</span>
            <span class="!text-xs"
              >Custom Policy Approval, edited sequence by sequence
            </span>
          </div>
        </mat-radio-button>
      </mat-radio-group>
      <div
        *ngIf="form.value.own_approval_flow"
        class="w-full p-8 border border-[#484848] rounded-md flex flex-col space-y-4"
      >
        <span class="font-medium">Approval Flow</span>
        <mat-select
          formControlName="approval_sequence"
          class="!w-2/3 h-12 rounded-lg !text-sm px-4 py-3 !text-[#5C5C5C] border border-gray-200 focus:outline-none !font-display !tracking-normal"
          placeholder="Pilih alur approval"
        >
          <mat-option
            [value]="true"
            class="!font-display !text-sm !tracking-normal"
            >Approval By Sequence/Order</mat-option
          >
          <mat-option
            [value]="false"
            class="!font-display !text-sm !tracking-normal"
            >Not Sequenced Approval</mat-option
          >
        </mat-select>
        <div class="flex items-center space-x-4 w-2/3">
          <mat-select
            #selectApprovalUser
            class="!w-2/3 h-12 rounded-lg !text-sm px-4 py-3 !text-[#5C5C5C] border border-gray-200 focus:outline-none !font-display !tracking-normal"
            placeholder="Pilih karyawan"
          >
            <ng-container *ngFor="let item of canSelectApprovalUser">
              <mat-option [value]="item.id"
                >{{ item.firstName }} {{ item.lastName }}</mat-option
              >
            </ng-container>
          </mat-select>
          <button
            type="button"
            (click)="addApprovalUser(selectApprovalUser.value)"
            class="h-12 px-4 rounded-md text-white bg-[#85E2B1] flex items-center justify-center text-sm"
          >
            Add
          </button>
        </div>
        <div
          *ngIf="selectedApprovalUser.length"
          class="w-full p-8 border border-[#484848] rounded-md flex flex-col space-y-4"
        >
          <div
            cdkDropList
            class="flex flex-col space-y-4"
            (cdkDropListDropped)="dropApprovalUser($event)"
          >
            @for (item of selectedApprovalUser; track item; let i = $index) {
            <div class="flex items-center space-x-4" cdkDrag>
              <span class="w-10 flex items-center justify-center">{{
                i + 1
              }}</span>
              <div
                class="p-4 rounded-lg border border-[#BABABA] bg-white flex justify-between items-center w-2/3 space-x-4"
              >
                <div class="flex items-center space-x-4">
                  <img
                    [src]="item.imageUrl || 'profile.png'"
                    alt="Foto Profil"
                    class="w-10 h-10 rounded-lg object-cover"
                  />
                  <div class="flex flex-col space-y-1">
                    <span class="!font-display text-sm"
                      >{{ item.firstName }} {{ item.lastName }}</span
                    >
                  </div>
                </div>
                <button
                  type="button"
                  (click)="removeApprovalUser(item.id)"
                  class="h-10 w-10 flex items-center justify-center bg-[#FFE1E0] text-[#FF6A65] rounded-md"
                >
                  <i class="fa-solid fa-trash"></i>
                </button>
              </div>
            </div>
            }
          </div>
        </div>
      </div>
    </div>
    <div class="lg:col-span-2 py-4">
      <mat-divider class="!border-gray-300"></mat-divider>
    </div>
    <div class="flex flex-col space-y-8 lg:col-span-2 w-full lg:w-2/3">
      <div class="flex flex-col space-y-2">
        <span class="font-semibold text-lg"
          >Assign Expense Categories to Teams</span
        >
        <span class="text-sm"
          >Assign specific expense categories to individual teams, with the
          option to choose multiple teams for each category</span
        >
      </div>
      <mat-radio-group
        aria-label="Select an option"
        formControlName="assign_specific_teams"
        class="flex flex-col space-y-4"
      >
        <mat-radio-button [value]="false">
          <div class="flex flex-col space-y-2 font-display">
            <span class="!text-base">All Teams</span>
          </div>
        </mat-radio-button>
        <mat-radio-button [value]="true">
          <div class="flex flex-col space-y-2 font-display">
            <span class="!text-base">Specific Teams</span>
          </div>
        </mat-radio-button>
      </mat-radio-group>
      <mat-select
        *ngIf="form.value.assign_specific_teams"
        formControlName="teams"
        class="!w-2/3 h-12 rounded-lg !text-sm px-4 py-3 !text-[#5C5C5C] border border-gray-200 focus:outline-none !font-display !tracking-normal"
        placeholder="Pilih team"
        [multiple]="true"
      >
        <ng-container *ngFor="let item of teams">
          <mat-option [value]="item.id">{{ item.name }}</mat-option>
        </ng-container>
      </mat-select>
    </div>
    <div class="lg:col-span-2 py-4">
      <mat-divider class="!border-gray-300"></mat-divider>
    </div>
    <div class="flex flex-col space-y-8 lg:col-span-2 w-full lg:w-2/3">
      <div class="flex flex-col space-y-2">
        <span class="font-semibold text-lg">Approval Remarks</span>
        <span class="text-sm">*You can choose multiple remarks type</span>
      </div>
      <div class="flex flex-col space-y-4">
        <mat-checkbox (change)="uncheckApprovalRemarks()" #noneApprovalRemarks>
          <div class="flex flex-col space-y-2 font-display">
            <span class="!text-base">None</span>
          </div>
        </mat-checkbox>
        <mat-checkbox
          formControlName="approval_note"
          (change)="noneApprovalRemarks.writeValue(false)"
        >
          <div class="flex flex-col space-y-2 font-display">
            <span class="!text-base">Note</span>
          </div>
        </mat-checkbox>
        <mat-checkbox
          formControlName="approval_upload_file"
          (change)="noneApprovalRemarks.writeValue(false)"
        >
          <div class="flex flex-col space-y-2 font-display">
            <span class="!text-base">Upload File</span>
          </div>
        </mat-checkbox>
      </div>
    </div>
    <div *ngIf="form.value.type == 'Cash Advance' || type == 'Cash Advance'" class="lg:col-span-2 py-4">
      <mat-divider class="!border-gray-300"></mat-divider>
    </div>
    <div
      *ngIf="form.value.type == 'Cash Advance' || type == 'Cash Advance'"
      class="flex flex-col space-y-8 lg:col-span-2 w-full lg:w-2/3"
    >
      <span class="font-semibold text-lg">Verification Flow</span>
      <mat-radio-group
        formControlName="verification_custom_flow"
        aria-label="Select an option"
        class="flex flex-col space-y-6"
      >
        <mat-radio-button [value]="false">
          <div class="flex flex-col space-y-2 font-display">
            <span class="!text-base">Same with approval flow</span>
            <span class="!text-xs"
              >Verification flow will have the same flow with approval</span
            >
          </div>
        </mat-radio-button>
        <mat-radio-button [value]="true">
          <div class="flex flex-col space-y-2 font-display">
            <span class="!text-base">Custom verification flow</span>
            <span class="!text-xs"
              >Custom Policy Verification, edited sequence by sequence
            </span>
          </div>
        </mat-radio-button>
      </mat-radio-group>
      <div
        *ngIf="form.value.verification_custom_flow"
        class="w-full p-8 border border-[#484848] rounded-md flex flex-col space-y-4"
      >
        <span class="font-medium">Verification Flow</span>
        <mat-select
          formControlName="verification_sequence"
          class="!w-2/3 h-12 rounded-lg !text-sm px-4 py-3 !text-[#5C5C5C] border border-gray-200 focus:outline-none !font-display !tracking-normal"
          placeholder="Pilih alur approval"
        >
          <mat-option
            [value]="true"
            class="!font-display !text-sm !tracking-normal"
            >Verification By Sequence/Order</mat-option
          >
          <mat-option
            [value]="false"
            class="!font-display !text-sm !tracking-normal"
            >Not Sequenced Verification</mat-option
          >
        </mat-select>
        <div class="flex items-center space-x-4 w-2/3">
          <mat-select
            #selectVerificator
            class="!w-2/3 h-12 rounded-lg !text-sm px-4 py-3 !text-[#5C5C5C] border border-gray-200 focus:outline-none !font-display !tracking-normal"
            placeholder="Pilih karyawan"
          >
            <ng-container *ngFor="let item of canSelectVerificatorUser">
              <mat-option [value]="item.id"
                >{{ item.firstName }} {{ item.lastName }}</mat-option
              >
            </ng-container>
          </mat-select>
          <button
            type="button"
            (click)="addVerificatorUser(selectVerificator.value)"
            class="h-12 px-4 rounded-md text-white bg-[#85E2B1] flex items-center justify-center text-sm"
          >
            Add
          </button>
        </div>
        <div
          *ngIf="selectedVerificatorUser.length"
          class="w-full p-8 border border-[#484848] rounded-md flex flex-col space-y-4"
        >
          <div
            cdkDropList
            class="flex flex-col space-y-4"
            (cdkDropListDropped)="dropVerificatorUser($event)"
          >
            @for (item of selectedVerificatorUser; track item; let i = $index) {
            <div class="flex items-center space-x-4" cdkDrag>
              <span class="w-10 flex items-center justify-center">{{
                i + 1
              }}</span>
              <div
                class="p-4 rounded-lg border border-[#BABABA] bg-white flex justify-between items-center w-2/3 space-x-4"
              >
                <div class="flex items-center space-x-4">
                  <img
                    [src]="item.imageUrl || 'profile.png'"
                    alt="Foto Profil"
                    class="w-10 h-10 rounded-lg object-cover"
                  />
                  <div class="flex flex-col space-y-1">
                    <span class="!font-display text-sm"
                      >{{ item.firstName }} {{ item.lastName }}</span
                    >
                  </div>
                </div>
                <button
                  type="button"
                  (click)="removeVerificatorUser(item.id)"
                  class="h-10 w-10 flex items-center justify-center bg-[#FFE1E0] text-[#FF6A65] rounded-md"
                >
                  <i class="fa-solid fa-trash"></i>
                </button>
              </div>
            </div>
            }
          </div>
        </div>
      </div>
    </div>
    <div class="lg:col-span-2 py-4">
      <mat-divider class="!border-gray-300"></mat-divider>
    </div>
    <div class="flex flex-col space-y-8 lg:col-span-2 w-full lg:w-2/3">
      <div class="flex flex-col space-y-2">
        <span class="font-semibold text-lg">Finance Option</span>
        <span class="text-sm"
          >Assign a specific finance/user to handle disbursement.</span
        >
      </div>
      <mat-radio-group
        formControlName="finance_all"
        aria-label="Select an option"
        class="flex flex-col space-y-6"
      >
        <mat-radio-button [value]="true">
          <div class="flex flex-col space-y-2 font-display">
            <span class="!text-base">All Finance</span>
          </div>
        </mat-radio-button>
        <mat-radio-button [value]="false">
          <div class="flex flex-col space-y-2 font-display">
            <span class="!text-base">Specific User Finance</span>
          </div>
        </mat-radio-button>
      </mat-radio-group>
      <div
        *ngIf="!form.value.finance_all"
        class="w-full p-8 border border-[#484848] rounded-md flex flex-col space-y-4"
      >
        <div class="flex items-center space-x-4 w-2/3">
          <mat-select
            #selectFinanceUser
            class="!w-2/3 h-12 rounded-lg !text-sm px-4 py-3 !text-[#5C5C5C] border border-gray-200 focus:outline-none !font-display !tracking-normal"
            placeholder="Pilih karyawan"
          >
            <ng-container *ngFor="let item of canSelectFinanceUser">
              <mat-option [value]="item.id"
                >{{ item.firstName }} {{ item.lastName }}</mat-option
              >
            </ng-container>
          </mat-select>
          <button
            type="button"
            (click)="addFinanceUser(selectFinanceUser.value)"
            class="h-12 px-4 rounded-md text-white bg-[#85E2B1] flex items-center justify-center text-sm"
          >
            Add
          </button>
        </div>
        @for (item of selectedFinanceUser; track item; let i = $index) {
        <div class="flex items-center space-x-4" cdkDrag>
          <div
            class="p-4 rounded-lg border border-[#BABABA] bg-white flex justify-between items-center w-2/3 space-x-4"
          >
            <div class="flex items-center space-x-4">
              <img
                [src]="item.imageUrl || 'profile.png'"
                alt="Foto Profil"
                class="w-10 h-10 rounded-lg object-cover"
              />
              <div class="flex flex-col space-y-1">
                <span class="!font-display text-sm"
                  >{{ item.firstName }} {{ item.lastName }}</span
                >
              </div>
            </div>
            <button
              type="button"
              (click)="removeFinanceUser(item.id)"
              class="h-10 w-10 flex items-center justify-center bg-[#FFE1E0] text-[#FF6A65] rounded-md"
            >
              <i class="fa-solid fa-trash"></i>
            </button>
          </div>
        </div>
        }
      </div>
    </div>
    <div class="flex items-center space-x-4 mt-8 lg:col-span-2">
      <button
        class="w-80 h-12 rounded-lg bg-[#85E2B1] text-white flex items-center justify-center space-x-2"
      >
        <span>Save</span>
      </button>
      <button
        type="button"
        (click)="cancel()"
        class="w-80 h-12 rounded-lg bg-gray-400 text-white flex items-center justify-center space-x-2"
      >
        <span>Cancel</span>
      </button>
    </div>
  </form>
</section>
